module.exports = __webpack_public_path__ + "images/organization/new-team.b0d9f513a05be128693e.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/organization/new-team.svg
// module id = Zmfa
// module chunks = 1